import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { switchMap, tap } from "rxjs/operators";
import { FileObj } from "src/app/model/user/file-obj";
import { DialogService } from "src/service/dialog.service";
import { FileService } from "src/service/file.service";
import { UserService } from "src/service/user.service";

@Component({
  selector: "app-profile-shareholder-section",
  templateUrl: "./profile-shareholder-section.component.html",

})
export class ProfileShareholderSectionComponent implements OnInit, OnChanges {
  constructor(
    private userService: UserService,
    private dialogService: DialogService,
    private fileService: FileService
  ) {}

  uploading = false;
  @Input("shareholders") shareholders;
  newShareholderNameInput: FormControl;
  newShareholderFileObj;
  currentFormData;
  currentFileName;

  ngOnChanges(changes: SimpleChanges): void {
    this.shareholders = changes.shareholders.currentValue;
  }

  ngOnInit(): void {
    this.newShareholderNameInput = new FormControl();
  }

  deleteShareholder(id) {
    return this.userService
      .deleteShareholder(id)
      .pipe(switchMap(() => this.userService.getUser()))
      .subscribe(
        () => this.dialogService.showSuccessDialog("SHAREHOLDER_DELETED"),
        (error) => this.dialogService.showErrorDialog(error.message)
      );
  }

  uploadShareholderFile(event) {
    this.currentFormData = this.fileService.getFormData(event).formData;
    this.currentFileName = this.fileService.getFormData(event).fileName;
  }

  addShareholder() {
    this.uploading = true;
    const newShareholderName = this.newShareholderNameInput.value;
    if (!newShareholderName || !this.currentFormData) {
      this.dialogService.showErrorDialog("FILL_MISSING_INFORMATION");
      this.uploading = false
      return;
    }

    this.userService
      .addShareHolder(newShareholderName, this.currentFormData)
      .pipe(
        tap(()=>this.uploading = false),
        switchMap(() => this.userService.getUser()),
        switchMap(() =>
          this.dialogService.showSuccessDialog("SHAREHOLDER_ADDED_SUCCESSFULLY")
        )
      )
      .subscribe(
        () => {
          this.uploading = false;
          this.currentFormData = null;
          this.currentFileName = null;
          this.newShareholderNameInput.setValue("");
        },
        (error) => {
          this.uploading = false;
          this.dialogService.showErrorDialog(error.message);
        }
      );
  }

  downloadFile(fileObj) {
    this.fileService.download(fileObj).subscribe(
      (response: HTMLAnchorElement) => {
        document.body.appendChild(response);
        response.click();
      },
      (error) => this.dialogService.showErrorDialog(error.message)
    );
  }
}
